import jfetch from '@jontetz/jfetch';

export function getCollections(data) {
    return jfetch.get('/api/widen/getCollectionsAsync', data);
}

export function getUrls(data) {
    return jfetch.get('/api/widen/getAssetsFromCollectionUrlAsync', data);
}